import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1425f5a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "right-menu" }
const _hoisted_3 = {
  class: "el-dropdown-link",
  style: {"cursor":"pointer"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 首页 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 个人中心 ")
const _hoisted_6 = {
  target: "_blank",
  href: "https://cpchain.io"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("官网")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"block"} }, "退出登录", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hamburger = _resolveComponent("hamburger")!
  const _component_breadcrumb = _resolveComponent("breadcrumb")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_hamburger, {
      "is-active": _ctx.sidebar.opened,
      class: "hamburger-container",
      onToggleClick: _ctx.toggleSideBar
    }, null, 8, ["is-active", "onToggleClick"]),
    _createVNode(_component_breadcrumb, { class: "breadcrumb-container" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_dropdown, {
        class: "avatar-container",
        trigger: "click"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, null, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/user-profile" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, null, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("a", _hoisted_6, [
                _createVNode(_component_el_dropdown_item, null, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_dropdown_item, {
                divided: "",
                onClick: _ctx.logout
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.name || 'CPChain') + " ", 1),
            _createVNode(_component_el_icon, {
              class: "el-icon--right",
              style: {"position":"absolute","margin-top":"0.05em"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_arrow_down)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ])
  ]))
}